<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12 eh-ds">
    <div class="header2">
      <h1 class="title">Current Diagnosis</h1>
      <button type="button" @click="showAddDiag">
        <font-awesome-icon :icon="['fas', 'plus-circle']" />
      </button>
    </div>
    <template v-if="isMobile()">
      <div
        :id="'diagnosismodal-overlay' + patient.id"
        class="modal-overlay eh-popup-overlay"
        style="display: none;"
        @click="closeDiag"
      >
      <form
        @submit.prevent="saveDiag"
        class="form-container eh-popup-panel"
        :id="'diagnosismodal' + patient.id"
        @click.stop
      >
        <h2>Diagnosis</h2>
        <div class="form-group">
          <label class="Mobile-label" for="icd-code">ICD-10 Code/Description *</label>
          <input class="Mobile-input" required v-model="diagSearchDescrip" name="icdCode" type="text" id="icd-code" placeholder="Type in your ICD code or description" @keyup.prevent="showDiagSearch">
          <div v-if="searchedDiags && searchedDiags.length != 0" class="icd10listcontainer">
            <div v-for="diag in searchedDiags" class="icd10srchlist" :key="diag.code" @click="clickDiag(diag)">
              <span id="icdcode">{{ diag.code }}</span> -
              <span id="icddesript">{{ diag.description }}</span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="Mobile-label" for="date">Date *</label>
          <input class="Mobile-input" type="date" required name="date" id="diagnosisDate" />
        </div>
        <button class="Mobile-button" type="submit">Save</button>
        <button class="Mobile-button" @click="closeDiag" type="button">Cancel</button>
      </form>
      </div>
    </template>
    <template v-else>
    <div
      :id="'diagnosismodal-overlay' + patient.id"
      class="modal-overlay eh-popup-overlay"
      style="display: none;"
      @click="closeDiag"
    >
    <form
      :id="'diagnosismodal' + patient.id"
      @submit.prevent="saveDiag"
      @click.stop
      class="diagnosismodal col-sm-12 col-md-12 col-lg-12 eh-popup-panel"
    >
      <!-- <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> -->
      <div class="modaltop">
        <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
          <h3>Diagnosis</h3>
        </section>
      </div>
      <div class="modalbottom">
        <!-- <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> -->
        <div class="icd10second col-sm-12 col-lg-12">
          <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-5">
            <label>ICD-10 Code/Description *</label>
            <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
            <br />
            <input
              required
              name="icdCode"
              type="text"
              id="srchnlookupterms"
              title="icd-10 diagnosis field"
              v-model="diagSearchDescrip"
              :placeholder="
                icdSearch
                  ? 'Type in your ICD code or a description'
                  : 'Type in your ICD Code'
              "
              @keyup.prevent="showDiagSearch"
            />
            <div
              v-if="searchedDiags && searchedDiags.length != 0"
              class="icd10listcontainer col-lg-12"
            >
              <div
                v-for="diag in searchedDiags"
                class="icd10srchlist"
                :key="diag.code"
                @click="clickDiag(diag)"
              >
                <span id="icdcode">{{ diag.code }}</span> -
                <span id="icddesript">{{ diag.description }}</span>
              </div>
            </div>
            <!-- <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> -->
          </div>
            <!-- <label>Onset/Exacerbation *</label><br />
                      <label>
                        <input type="radio" id="onsetkbox" name="onOrExac" value="Onset" />Onset</label
                      >
                      <label
                        ><input
                          type="radio"
                          id="excaberationchkbox"
                          name="onOrExac"
                          value="Exacerbation"
                        />Exacerbation</label -->
          <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-4">
            <label>Date *</label><br />
            <input type="date" id="diagnosisDate" required name="date" />
          </div>
        </div>
        <div class="icd10thrid col-sm-12 col-lg-12">
          <!-- <div id="icd10thirdRating">
                      <label>System Control Rating </label><br />
                      <input type="number" id="controlnumber" />
                    </div> -->
        </div>
        <div class="icd10fourth col-sm-12 col-lg-12">
          <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
            <input type="submit" id="savediagnbtn" value="Save" />
            <input type="button" id="canceldiagbtn" value="Cancel" @click="closeDiag" />
          </div>
        </div>
      </div>
      <!--end Order Grid for Modal-->
    </form>
    </div>
  </template>
    <template v-if="isMobile()">
      <div v-if="allDiags" class="table-container">
        <div class="accordion">
          <div
            v-for="(diag, index) in sortedDiagnoses"
            :key="'diag' + index"
            :id="'diag' + index"
            @click="showDiag(index)"
            class="accordion-item"
          >
            <button class="accordion-button">{{ diag.diagnosis_code }}</button>
            <div class="accordion-content">
              <p><b>Date: </b>{{ `${diag.diagnosis_date}` }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container">
        <table>
          <thead>
            <tr>
              <th>Diagnosis</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody v-if="allDiags">
            <tr v-for="(diag, index) in sortedDiagnoses" :key="'diag' + index">
              <td data-label="Diagnosis" class="diagrow">{{ diag.diagnosis_code }}</td>
              <td data-label="Date">{{ diag.diagnosis_date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";

export default {
  name: "CurrentDiag",
  data() {
    return {
      icdSearch: true,
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch
      allDiags: null, // List of diagnosis already saved for patient
    };
  },
  async mounted() {
    this.loadDiagnosis();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    sortedDiagnoses: function () {
      if (!this.allDiags || !Array.isArray(this.allDiags)) {
        return [];
      }
      const reversed = [...this.allDiags].reverse();
      return reversed.sort((a, b) => {
        const dateA = a.diagnosis_date ? new Date(a.diagnosis_date) : new Date(0);
        const dateB = b.diagnosis_date ? new Date(b.diagnosis_date) : new Date(0);
        if (dateA.getTime() !== dateB.getTime()) {
          return dateB - dateA;
        }
        return 0;
      });
    },
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showDiag(index) {
      let entry = document.getElementById(`diag${index}`);
      entry.classList.toggle("active");
    },
    async loadDiagnosis() {
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.gridhtml) {
            this.allDiags = res.data.data.filter(
              (diag) => diag.diagnosis_type === "Diagnosis"
            );
            console.log(this.allDiags);
          } else {
            this.allDiags = null;
          }
        });
    },

    async saveDiag() {
      let form = document.getElementById("diagnosismodal" + this.patient.id);
      let content = {
        Diagnosis: {
          API_Meth: "InsertDiagnosis",
          ordernumber: 0,
          diagnosis_type: "Diagnosis",
          onset_exacerbation: "",
          diagnosisDate: form.elements["date"].value ? form.elements["date"].value : null,
          endDate: null,
          diagControlRating: "",
          diagcode: form.elements["icdCode"].value,
          proccode: "",
          pid: this.patient.externId,
          status: "Active",
          instruction: "",
          // Staff sessions use manager; patient self-service has no manager — use patient name.
          writer:
            this.allData.manager?.name ||
            [this.patient?.firstName, this.patient?.lastName].filter(Boolean).join(" ") ||
            this.patient?.name ||
            "",
        },
      };
      console.log(content);
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.result && res.data.result == "Inserted") {
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.loadDiagnosis();
            alert("Diagnosis successfully added");
            this.closeDiag();
          } else {
            alert(
              "Error with diagnosis insertion. Try again or contact an administrator."
            );
          }
        });
    },
    async showDiagSearch() {
      if (this.diagSearchDescrip == "") {
        this.searchedDiags = [];
        return;
      }
      if (true) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    showAddDiag() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.DIAGNOSIS_ADD,
          "You do not have permission to add diagnoses."
        )
      ) {
        return;
      }
      const overlay = document.getElementById(
        "diagnosismodal-overlay" + this.patient.id
      );
      if (overlay) {
        overlay.style.display = "flex";
      } else {
        $("#diagnosismodal" + this.patient.id).css("display", "block");
      }
    },
    closeDiag() {
      let form = document.getElementById("diagnosismodal" + this.patient.id);
      if (form) {
        form.reset();
        form.style.display = "none";
      }
      const overlay = document.getElementById(
        "diagnosismodal-overlay" + this.patient.id
      );
      if (overlay) {
        overlay.style.display = "none";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.title {
  margin-right: 20px;
}

.accordion {
  margin-top: 10px;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button {
  padding: 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 18px;
}

.accordion-content {
  display: none;
  padding: 15px;
}

.accordion-item.active .accordion-content {
  display: block; /* Show content when item is active */
}

.form-container {
  padding: 20px;
  width: 90%;
  margin: 0 auto;
  display: none;
  position: absolute;
  z-index: 20;
  /* Shared popup border/surface only. */
  border: var(--eh-popup-border) !important;
  border-radius: var(--eh-popup-radius) !important;
  background: var(--eh-popup-surface) !important;
  box-shadow: none !important;
}
.modal-overlay {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.modal-overlay[style*="display: flex"] .form-container,
.modal-overlay[style*="display: flex"] .diagnosismodal {
  display: block;
}
.diagnosismodal {
  /* Layout matches keyon.scss original (70% × 70%, centered). */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  overflow: auto;
  z-index: 10001;
  display: none;
  /* Shared popup border/surface only — do not change size/position above. */
  border: var(--eh-popup-border) !important;
  border-radius: var(--eh-popup-radius) !important;
  background: var(--eh-popup-surface) !important;
  box-shadow: none !important;
}
.form-group {
  margin-bottom: 20px;
}

.Mobile-label {
    display: block;
    margin-bottom: 5px;
}

.Mobile-input, .Mobile-select, .Mobile-button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.Mobile-button {
    margin-top: 10px;
    border: none;
    cursor: pointer;
  }

  @media only screen and (max-width: 576px) {
  //   body {
  //   font-family: Arial, sans-serif;
  //   padding: 10px;
  // }
    .icd10listcontainer{
      max-height: 200px;
    }
  }
  body {
  margin: 0;
  padding: 0;
}
.container {
  margin: 20px auto;
  overflow-x: auto;
}
h2 {
  text-align: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #d3d7db;
}
.button-container {
  text-align: center;
  margin: 20px 0;
}
.button-container button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.diagrow {
  width: 60%;
}
</style>
